import { InjectionToken } from '@angular/core';

import { ISettingsApiModel } from '../models/api/settings.api.model';

export const APP_CONFIG = new InjectionToken<IAppConfig>('APP_CONFIG');

export interface IAppConfig {
  settings: ISettingsApiModel;
  configsUrl: string;
}
